import {BaseFormModel} from './base-form-model';
import {MenuModifierSelection} from './menu-modifier-selection';
import {MenuItemModifierSelectionOption} from './menu-item-modifier-selection-option';

export class MenuItemModifierSelection extends BaseFormModel<MenuItemModifierSelection> {
    id: number;
    menuModifierSelection: MenuModifierSelection;
    sortOrder: number;
    options: MenuItemModifierSelectionOption[];
}
